namespace app.tarefas {
    "use strict";
    
    import MinhasTarefasService = app.tarefas.minhasTarefas.MinhasTarefasService;
    import CommandService = app.support.command.CommandService;
    
    export class TarefasDetailsController {
        /** @ngInject **/
        constructor(
            private $stateParams: angular.ui.IStateParamsService, 
            private $state: ng.ui.IStateService, context, id,
            private minhasTarefasService: MinhasTarefasService,
            private commandService: CommandService
        ) {
            this.minhasTarefasService.get().then(tasks => {
                let task: any = tasks.find(task => task.context == context && task.id == id);
                if (task) {  
                    this.redirecionar(task);
                } else {
                    this.$state.go('app.tarefas');  
                }
            });
       
        }

        private redirecionar(task) {            
            this.commandService.findByIdAndContext(task.command, task.context).then(command => {
                let contextTask = angular.copy(task);
                this.$state.go(command.route.stateName, Object.assign({ task: contextTask }));   
            });            
        }        
        
        public $onInit(): void {

        }
    }

    angular
        .module('app.tarefas')
        .controller('app.tarefas.TarefasDetailsController', TarefasDetailsController);
}